import * as React from "react";
import { useSelector, useDispatch } from "@teamprevent/admin-redux";

import { Modal, Form, Button } from "semantic-ui-react";

import { Input } from "@neworbit/simpleui-input";

import { navigateToParentRoute } from "@teamprevent/common/routing/actions";

import { ApplicationState } from "../../../applicationState";
import { routeIdSelector as customerIdSelector } from "../../../crud/customer/selectors";
import { routeIdSelector as employeeRecordIdSelector } from "../../../crud/employeeRecord/selectors";
import { PhysiotherapyReferralOrigin, PhysiotherapyReferralOriginOptions } from "../../models";

import { push } from "redux-little-router";

interface OwnProps {
    linkedOhCaseId?: string;
    open: boolean;
}

const CreatePhysiotherapyReferralCaseModal: React.FunctionComponent<OwnProps> = (props: OwnProps) => {
    const dispatch = useDispatch();

    const [physiotherapyOrigin, setPhysiotherapyOrigin] = React.useState<PhysiotherapyReferralOrigin>(null);
    const [submitted, setSubmitted] = React.useState<boolean>(false);

    const customerId = useSelector((state: ApplicationState) => customerIdSelector(state));
    const employeeRecordId = useSelector((state: ApplicationState) => employeeRecordIdSelector(state));

    const onChangeOrigin = (origin: PhysiotherapyReferralOrigin) => {
        setPhysiotherapyOrigin(origin);
    };

    const navigateToRoute = () => {
        dispatch(navigateToParentRoute());
    };

    const createPhysiotherapyMgrReferralCase = () => {
        if (props.linkedOhCaseId) {
            // eslint-disable-next-line max-len
            dispatch(push(`/customers/${customerId}/employeeRecords/${employeeRecordId}/ohCases/${props.linkedOhCaseId}/createPhysiotherapyMgrReferralCase/${props.linkedOhCaseId}`));
        } else {
            dispatch(push(`/customers/${customerId}/employeeRecords/${employeeRecordId}/ohCases/createPhysiotherapyMgrReferralCase`));
        }
    };

    const createPhysiotherapySelfReferralCase = () => {
        if (props.linkedOhCaseId) {
            // eslint-disable-next-line max-len
            dispatch(push(`/customers/${customerId}/employeeRecords/${employeeRecordId}/ohCases/${props.linkedOhCaseId}/createPhysiotherapySelfReferralCase/${props.linkedOhCaseId}`));
        } else {
            dispatch(push(`/customers/${customerId}/employeeRecords/${employeeRecordId}/ohCases/createPhysiotherapySelfReferralCase`));
        }
    };

    const handleCreateCase = () => {
        setSubmitted(true);
        if (!physiotherapyOrigin) {
            return;
        }
        if (physiotherapyOrigin === PhysiotherapyReferralOrigin.SELF) {
            createPhysiotherapySelfReferralCase();
        } else {
            createPhysiotherapyMgrReferralCase();
        }
    };

    return (
        <Modal open={props.open}>
            <Modal.Header content="Create Physiotherapy Referral Case" />
            <Modal.Content>
                <Form>
                    <Input.Dropdown
                        required
                        value={physiotherapyOrigin}
                        showErrors={submitted}
                        label="Physiotherapy referral origin"
                        options={PhysiotherapyReferralOriginOptions}
                        onChange={onChangeOrigin}
                    />
                </Form>
            </Modal.Content>
            <Modal.Actions>
                <Button content="Cancel" onClick={navigateToRoute} />
                <Button content="Create" onClick={handleCreateCase} />
            </Modal.Actions>
        </Modal>
    );
};

export { CreatePhysiotherapyReferralCaseModal };
